import { render, staticRenderFns } from "./FeaturedVerticalListComponent.vue?vue&type=template&id=3f153ca4"
import script from "./FeaturedVerticalListComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedVerticalListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports